<template>
  <div class="status"
    :class="clmod">
      <span class="status__title" v-if="title.length !== 0">{{ title }}</span>
      <span class="status__main"
        :class="getStatusClass()"
      >{{statused}}</span>
      <span class="status__dt" v-if="lmdate.length !== 0">Изменен: {{ StringIsoDateToRus(lmdate) }}</span>
  </div>
</template>

<script>
import { StringIsoDateToRus } from '@/common/utils.js';

export default {
name: "StatusComponent",
  props: {
    statused: {
      type: String,
      default: ""
    },
    solutioncode: {
      type: String,
      default: "0"
    },
    lmdate: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    clmod: {
      type: String,
      default: ""
    },
  },
  methods: {
    getStatusClass() {
      switch(this.statused.toLowerCase()) {
        case "отказ в регистрации дт": 
        case "отказано в корректировке":
        case "процедура закрыта": return "status__main-process";
        case "окончательный выпуск":
        case "решение по дт принято":
          switch (parseInt(this.solutioncode)) {
            case 10: return "status__main-done";
            case 90: return "status__main-process";
            default: return "status__main-details";
          }
        case "дт отозвана": return "status__main-details";
        default: return "status__main-opened"
      }
    },
    StringIsoDateToRus(_date) {
      return StringIsoDateToRus(_date)
    }
  }
}
</script>